import { isValid } from 'date-fns/isValid';
import { parseISO } from 'date-fns/parseISO';

type IsValidDateReturn<T, R> = { result: boolean; value: R extends false ? T : Date };

const isValidDate = <T, R extends boolean>(value: T): IsValidDateReturn<T, R> => {
    try {
        const date = parseISO(String(value));
        const result = isValid(date);
        return { result, value: result ? date : value } as IsValidDateReturn<T, R>;
    } catch (e: any) {
        console.log('isValidDate', e);
        return { result: false, value } as IsValidDateReturn<T, R>;
    }
};

export { isValidDate };

export { UTCDate, utc } from '@date-fns/utc';
export {
    compareAsc,
    compareDesc,
    differenceInHours,
    differenceInMinutes,
    differenceInSeconds,
    eachDayOfInterval,
    eachHourOfInterval,
    eachMinuteOfInterval,
    eachMonthOfInterval,
    eachQuarterOfInterval,
    eachWeekOfInterval,
    endOfDay,
    endOfHour,
    endOfMinute,
    endOfMonth,
    endOfQuarter,
    endOfWeek,
    endOfYear,
    format,
    formatDistance,
    formatDistanceStrict,
    formatDistanceToNow,
    formatDistanceToNowStrict,
    fromUnixTime,
    getDaysInMonth,
    getWeeksInMonth,
    intervalToDuration,
    isAfter,
    isBefore,
    isSameDay,
    isToday,
    isValid,
    isWithinInterval,
    parseISO,
    startOfDay,
    startOfMonth,
    startOfQuarter,
    startOfWeek,
    startOfYear,
    sub,
} from 'date-fns';
export { formatInTimeZone, fromZonedTime, toZonedTime } from 'date-fns-tz';
